// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikInput } from "src/components/Forms/TextInput";

interface Props {}

const Address: React.FC<Props> = () => {
  return (
    <Field label="Address:" mb={26}>
      <FormikInput
        name="address"
        size="middle"
        placeholder="e.g. 39 Dressing Crescent, SE14 653"
        borderRadius={2}
        borderColor="grey5"
      />
    </Field>
  );
};

export default Address;
